<script>
import { getVehicleList } from "@/api/vehicle";
import { showPhoneAlarm } from "@/global/function.js";

export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      searchkey: "",
      loading: false,
      vehicleList: [],
    };
  },
  computed: {
    showPop: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    title() {
      return "选择车辆";
    },
    showVehicleList() {
      if (this.searchkey) {
        const list = this.vehicleList.filter((vehicle) => {
          if (vehicle.vehicleNo && vehicle.vehicleNo.includes(this.searchkey)) {
            return true;
          }
          if (vehicle.vehicleName && vehicle.vehicleName.includes(this.searchkey)) {
            return true
          }
          return false;
        });
        return list;
      }
      return this.vehicleList;
    },
  },
  created() {
    this.getVehicle();
  },
  methods: {
    async getVehicle() {
      this.loading = true;
      const response = await getVehicleList().catch(() => false);
      this.loading = false;
      if (response) {
        const { data } = response;
        if (
          showPhoneAlarm(
            false,
            "toast",
            null,
            2000,
            data.code,
            null,
            data.message
          )
        ) {
          this.vehicleList = data.data;
        }
      }
    },
  },
};
</script>

<template>
  <van-popup
    v-model="showPop"
    round
    position="bottom"
    closeable
    close-icon-position="top-right"
  >
    <div class="edit-pop">
      <div class="edit-pop-title">
        <div>{{ title }}</div>
        <div class="edit-pop-subtitle">
          搜索已录入车辆
        </div>
      </div>
      <van-search
        v-model="searchkey"
        show-action
        label="车牌号"
        placeholder="请输入搜索关键词"
      />
      <div
        v-if="loading"
        class="list-loading"
      >
        <van-loading size="24px">
          加载中...
        </van-loading>
      </div>
      <div
        v-else-if="vehicleList.length"
        style="height: calc(100% - 131px); overflow: auto"
      >
        <van-cell
          v-for="vehicle of showVehicleList"
          :key="vehicle.id"
          :title="vehicle.vehicleName || '未命名'"
          :value="vehicle.vehicleNo"
          is-link
          @click="$emit('selected', vehicle)"
        />
      </div>
      <div v-else>
        <van-empty description="无可选车辆" />
      </div>
    </div>
  </van-popup>
</template>

<style lang="scss" scoped>
.edit-pop {
  height: 50vh;
  .edit-pop-title {
    font-size: 18px;
    font-weight: bold;
    padding: 16px 24px;
  }
  .edit-pop-subtitle {
    font-size: 14px;
    color: gray;
    font-weight: lighter;
  }
  .list-loading {
    padding: 16px;
    text-align: center;
  }
}
</style>